import { render, staticRenderFns } from "./icon-tags-folder.vue?vue&type=template&id=147058b9&"
import script from "./icon-tags-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-tags-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports